import hrMessages from '../locales/hr_HR';

const HrLang = {
  messages: {
    ...hrMessages,
  },
  locale: 'hr-HR',
};
export default HrLang;
